module.exports = __webpack_public_path__ + "assets/side-close.c064a9ec.svg";